import workspaceQuery from '../../../graphql/queries/company/CompanyUserNotificationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CompanyUserNotificationListQuery.graphql';
import mutationQuery from '../../../graphql/mutations/company/CompanyUserNotificationMutation.graphql';
import { EntityType } from '../../../@types/entityTypes';

const CompanyUserNotification: EntityType = {
  type: 'CompanyUserNotification',
  title: 'User Notifications',
  workspaceUrl: '/Company/UserNotification/Workspace/',
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  screenReference: 'USER_NOTIFICATIONS',
};

export default CompanyUserNotification;
